module.exports = "/static/js/cb01c2434c0dabc60d94f8bacae72373.png";